"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _rowConfig = _interopRequireDefault(require("../../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../../core/form-group"));
var _input = _interopRequireDefault(require("../../../../core/input"));
var _label = _interopRequireDefault(require("../../../../core/label"));
var _col = _interopRequireDefault(require("../../../../core/col"));
var _occasion = _interopRequireDefault(require("occasion"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement(_label.default, null, "Application Status:");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "SlalomSite:");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Start Date:");
var _ref4 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Number of days spanned by Competition");
var _ref5 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Organising Club:");
var _ref6 = /*#__PURE__*/_react.default.createElement(_label.default, null, "2nd Organising Club if applicable:");
var _ref7 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Weeks by which competition could move:");
var _ref8 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Notes:");
var _ref9 = /*#__PURE__*/_react.default.createElement("div", {
  className: "card-header"
}, "Contact Details");
var _ref10 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Contact Name:");
var _ref11 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Contact Email:");
var _ref12 = /*#__PURE__*/_react.default.createElement("div", {
  className: "card-header"
}, "Risk Assesment");
var _ref13 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Received:");
class ApplicationCore extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_setValue", (value, field) => {
      this.props.setValue(this.props.application.id, value, field);
    });
  }
  render() {
    const application = this.props.application;
    const userIsSafetyOfficer = this.props.userIsSafetyOfficer;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        xs: 5
      }, {
        xs: 7
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref, /*#__PURE__*/_react.default.createElement(_col.default, null, application.applicationStatusDescription)), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, application.site.location)), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, /*#__PURE__*/_react.default.createElement(_col.default, null, (0, _occasion.default)(application.calendarDateID, 'D MMMM YYYY'))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref4, /*#__PURE__*/_react.default.createElement(_col.default, null, application.numberOfDays)), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref5, /*#__PURE__*/_react.default.createElement(_col.default, null, application.club1.clubName)), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref6, /*#__PURE__*/_react.default.createElement(_col.default, null, application.club2 && application.club2.clubName)), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref7, /*#__PURE__*/_react.default.createElement(_col.default, null, application.canMoveByWeeks || 0)), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref8, /*#__PURE__*/_react.default.createElement(_col.default, null, application.notes || 'None'))), !application.canShareContact && !application.isAdministratedByUser ? null : /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, _ref9, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        xs: 5
      }, {
        xs: 7
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref10, /*#__PURE__*/_react.default.createElement(_col.default, null, application.contactName)), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref11, /*#__PURE__*/_react.default.createElement(_col.default, null, application.contactEmail))))), !userIsSafetyOfficer ? null : /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, _ref12, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        xs: 5
      }, {
        xs: 7
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref13, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      checked: application.hasRiskAssessment,
      name: "hasRiskAssessment",
      onChange: this._setValue
    })))))));
  }

  // *******************************************************************************
  // Partial Queries
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(ApplicationCore, "partialQueries", {
  Application: {
    id: true,
    isAdministratedByUser: true,
    competitionName: true,
    calendarDateID: true,
    numberOfDays: true,
    canMoveByWeeks: true,
    notes: true,
    applicationStatusRef: true,
    contactName: true,
    contactEmail: true,
    canShareContact: true,
    applicationStatusDescription: true,
    site: {
      location: true
    },
    club1: {
      clubName: true
    },
    club2: {
      clubName: true
    },
    hasRiskAssessment: true
  }
});
var _ref14 = {
  userIsSafetyOfficer: true
};
var _default = exports.default = (0, _reactBicycle.connect)(ApplicationCore, props => _ref14, (client, props) => ({
  setValue(id, value, field) {
    return client.update('Application.set', {
      id,
      value,
      field
    });
  }
}));